export default __webpack_public_path__ + "static/media/whatsapp.26af51b7.svg";